export const DEVELOPMENT_ENVIRONMENT_BASE_URL = 'http://localhost:3000/api';
